import {useQuery} from 'react-query';
import {getBrandDetailById} from './getBrandDetailById';

const useGetBrandDetailById = (brandId?: string) => {
  const {data, isLoading} = useQuery(
    ['get-brand-detail-by-id', brandId],
    () => getBrandDetailById(brandId),
    {enabled: Boolean(brandId)},
  );

  return {data, isLoading};
};

export default useGetBrandDetailById;
